import React, { useEffect } from 'react';
import Icon from '@mdi/react';
import { observer } from 'mobx-react';
import './ButtonBlock.scss';
import stores from 'cd-eft/models/Stores';
const designStore = stores.AppStore?.designStore;

interface IButtonBlockProps {
  buttons: any;
  className?: string;
}

interface IButton {
  icon?: any;
  img?: any;
  title: string;
  disabled: boolean;
  onClick: any;
  className?: string;
  alt?: string;
  imgClassName?: string;
}

// if you want to align any button to the left, pass for that button className="mr-auto"
export const ButtonBlock = observer(({ buttons = [], className = '' }: IButtonBlockProps) => {
  let filteredButtons = buttons;
  if (!designStore.shouldHumanFeedbackOn) {
    filteredButtons = buttons.filter((el: IButton) => el.alt !== 'ai-training-data');
  }

  return (
    <div className={`button-block ${className ? className : ''}`}>
      {filteredButtons.map((el: IButton) => (
        <button
          key={el.title || el.alt}
          className={`usa-button nobr ${el.disabled ? 'usa-button--disabled' : ''} ${el.className ? el.className : ''
            } ${!el.icon && !el.img ? 'px-3' : ''}`}
          disabled={el.disabled}
          onClick={el.onClick}
          data-testid={`${el.title || el.alt}-button`}
        >
          {el.icon ? (
            <Icon
              path={el.icon}
              title={el.alt ? el.alt : el.title}
              size={1}
              className={`esri-collapse__icon esri-icon-public ${el.title ? 'mr-2' : ''}`}
            />
          ) : el.img ? (
            <img className={el.imgClassName} alt={el.alt} src={el.img} />
          ) : null}
          {el.title}
        </button>
      ))}
    </div>
  );
});
